import { render, staticRenderFns } from "./ListDocumentTemplate.vue?vue&type=template&id=74a6ab9c"
import script from "./ListDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./ListDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListDocumentTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a6ab9c')) {
      api.createRecord('74a6ab9c', component.options)
    } else {
      api.reload('74a6ab9c', component.options)
    }
    module.hot.accept("./ListDocumentTemplate.vue?vue&type=template&id=74a6ab9c", function () {
      api.rerender('74a6ab9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/views/ListDocumentTemplate.vue"
export default component.exports